import { render, staticRenderFns } from "./view-user.vue?vue&type=template&id=48cd5606"
import script from "./view-user.vue?vue&type=script&lang=js"
export * from "./view-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports